import Duck from 'extensible-duck';
import toast from 'simple-pure-toast';
import { get, post, put } from '../../utils/request';
import {
  convertDateFinish,
  convertDateInit,
  fechaActual,
  fechaInicial,
  handlerRequestErrors,
  msjCommon,
  statusesCommon,
  typesCommon,
  typeToast,
  getCurrentLiteralRoleType
} from '../../utils/helpers';

const initialState = {
  message: '',
  status: '',
  loadingDeep: false,
  indicadoresOperativos: [],
  indicadoresCuantitativos: [],
  indicadoresCualitativos: [],
  detailSaleDeep: [],
  detalledeep: {
    indicadoresCualitativos: [],
    indicadoresExplicativos: [],
    indicadoresOperativos: []
  },
  step: {
    RESULTADO: 'RESULTADO_INDICADORES',
    PROCESO: 'PROCESO_VENTA',
    COACHING: 'COACHING',
    ESCUCHA: 'ESCUCHA',
    PLAN: 'PLAN_ACCION',
    RESUMEN: 'RESUMEN'
  }
};

const getInitialState = ({statuses}) => ({
  ...initialState,
  status: statuses.NEW
});

export default new Duck({
  namespace: 'converti',
  store: 'deep',
  consts: {
    statuses: [
      ...statusesCommon,
      'LOADING_LIST_INDICADORES',
      'READY_DETAIL_DEEP',
      'READY_LISTA_INDICADORES',
      'SAVE_DEEP',
      'SAVE_DEEP_CIERRE'
    ]
  },
  types: [
    ...typesCommon,
    'FETCH_FULLFILLED_LIST_DEEP',
    'FETCH_PENDING_LIST_INDICADORES',
    'FETCH_FULLFILLED_LIST_INDICADORES',
    'POST_FULLFILLED_REGISTER_DEEP',
    'PUT_FULLFILLED_REGISTER_DEEP_CIERRE',
    'DETALLE_ACCION_DEEP',
    'RESET_DEEP_DUCK'
  ],
  initialState: getInitialState,
  reducer: (state, action, { types, statuses }) => {
    switch (action.type) {
      case types.POST_FULLFILLED_REGISTER_DEEP:
        toast.success(msjCommon('listo'), { description: 'Se registró la acción Deep' });
        return {
          ...state,
          status: statuses.SAVE_DEEP
        };

      case types.PUT_FULLFILLED_REGISTER_DEEP_CIERRE:
        return {
          ...state,
          status: statuses.SAVE_DEEP_CIERRE
        };

      case types.FETCH_PENDING_LIST_INDICADORES:
        return {
          ...state,
          indicadoresCuantitativos: [],
          status: statuses.LOADING_LIST_INDICADORES
        };

      case types.FETCH_FULLFILLED_LIST_INDICADORES:
        return {
          ...state,
          indicadoresOperativos: action.payload.indicadoresCuantitativos.filter((o) => o.subTipo === 'RESULTADO').map(({ id: idIndicador, nombre: nombreIndicador, subTipo: subTipoIndicador, ...rest }) => ({ idIndicador, nombreIndicador, subTipoIndicador, valorActual: 0, valorObjetivo: 0, ...rest })),
          indicadoresCuantitativos: action.payload.indicadoresCuantitativos.filter((o) => o.subTipo === 'EXPLICATIVO').map(({ id: idIndicador, nombre: nombreIndicador, subTipo: subTipoIndicador, ...rest }) => ({ idIndicador, nombreIndicador, subTipoIndicador, ...rest })),
          indicadoresCualitativos: action.payload.indicadoresCualitativos.map(({ id: idIndicador, nombre: nombreIndicador, subTipo: subTipoIndicador, ...rest }) => ({ idIndicador, nombreIndicador, subTipoIndicador, ...rest })),
          status: statuses.READY_LISTA_INDICADORES
        };

      case types.FETCH_FULLFILLED_LIST_DEEP:
        return {
          ...state,
          detailSaleDeep: action.payload,
          status: statuses.READY_DETAIL_DEEP
        };

      case types.CREATOR_FAILD:
        toast.error(msjCommon('fallo'), { description: action.payload.message, position: 'bottomRight' });
        return { ...state, status: statuses.ERROR };

      case types.LOADING_EFFECT:
        return {
          ...state,
          loadingDeep: action.loadingDeep
        };

      case types.TOAST:
        typeToast(action.data.toast, action.data.payload.message);
        return { ...state, loadingDeep: action.data.loadingDeep };

      case types.DETALLE_ACCION_DEEP:
        return {
          ...state,
          detalledeep: { ...action.payload }
        };

      case types.RESET_DEEP_DUCK:
        return getInitialState({ statuses })

      default:
        return state;
    }
  },
  selectors: {
    root: (state) => state
  },
  creators: ({ types }) => ({
    getSaleDetailDeep: (filters = {}) => async (dispatch, getState) => {
      try {
        dispatch({ type: types.LOADING_EFFECT, loadingDeep: true });
        const {
          auth: {
            rolActual, rol,
            user: { userId }
          }
        } = getState();
        const { payload } = await get(
          `/acciones-deep/`,
          {
            queryStringParameters: {
              idCreador: (rolActual === rol.asesor || filters.idCreador === null)
                ? null
                : filters.idCreador === undefined
                  ? userId
                  : filters.idCreador,
              idAsignado: rolActual === rol.asesor ? userId : filters.idAsignado,
              fechaInicio: filters.fec_inicio ? convertDateInit(filters.fec_inicio) : convertDateInit(fechaInicial),
              fechaFin: filters.fec_fin ? convertDateFinish(filters.fec_fin) : convertDateFinish(fechaActual)
            }
          }
        );
        dispatch({ type: types.FETCH_FULLFILLED_LIST_DEEP, payload });
        dispatch({ type: types.LOADING_EFFECT, loadingDeep: false });
      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.LOADING_EFFECT, loadingDeep: false });
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },

    registerDeep: (requestPayload = {}) => async (dispatch) => {
      try {
        dispatch({ type: types.LOADING_EFFECT, loadingDeep: true });
        const json = { payload: requestPayload };
        const { payload } = await post('/acciones-deep', json);
        dispatch({ type: types.POST_FULLFILLED_REGISTER_DEEP, payload });
        dispatch({ type: types.LOADING_EFFECT, loadingDeep: false });
      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.LOADING_EFFECT, loadingDeep: false });
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },

    updateDeepCierre: (requestPayload) => async (dispatch) => {
      try {
        const json = {
          payload: {
            ...requestPayload.payload
          }
        };

        dispatch({ type: types.LOADING_EFFECT, loadingDeep: true });

        const { payload } = await put(`/acciones-deep/${requestPayload.id}/cierre`, json);

        dispatch({ type: types.PUT_FULLFILLED_REGISTER_DEEP_CIERRE, payload });

        toast.success('¡Listo!', { description: 'Se cerró la acción Deep.' });

        dispatch({ type: types.LOADING_EFFECT, loadingDeep: false });

      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.LOADING_EFFECT, loadingDeep: false });
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },

    updateDeepCierreJefe: (requestPayload) => async (dispatch) => {
      try {
        dispatch({ type: types.LOADING_EFFECT, loadingDeep: true });
        const json = {
          request: {
            payload: {
              ...requestPayload
            }
          }
        };
        const { response: { status, payload } = {} } = await put(`/rimacpower/accion/deep/cierre/jefe`, json);
        let data = { payload, loadingDeep: false };
        if (status.success) {
          data = { ...data, toast: 'success' };
        } else {
          data = { ...data, toast: 'error' };
        }
        dispatch({ type: types.TOAST, data });
      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.LOADING_EFFECT, loadingDeep: false });
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },

    getIndicadores: () => async (dispatch, getState) => {
      const { auth: { canalActual, rol, rolActual } } = getState();
      try {
        const { payload } = await get(`/canales/${canalActual}/indicadores?rol=${getCurrentLiteralRoleType(rolActual, rol)}`);
        dispatch({
          type: types.FETCH_FULLFILLED_LIST_INDICADORES,
          payload
        });
      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },

    detalleAccionDeep: (idaccion) => async (dispatch) => {
      try {
        dispatch({ type: types.LOADING_EFFECT, loadingDeep: true });
        const { payload } = await get(`/acciones-deep/${idaccion}`);
        dispatch({ type: types.DETALLE_ACCION_DEEP, payload });
        dispatch({ type: types.LOADING_EFFECT, loadingDeep: false });
      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.LOADING_EFFECT, loadingDeep: false });
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },

    actualizarEstadoDeep: (requestPayload = {}) => async (dispatch) => {
      try {
        dispatch({ type: types.LOADING_EFFECT, loadingDeep: true });

        await put(`/acciones-deep/${requestPayload.id}`);

        toast.success('¡Listo!', { description: 'Se está siguiendo la acción Deep.' });

        dispatch({ type: types.LOADING_EFFECT, loadingDeep: false });

      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.LOADING_EFFECT, loadingDeep: false });
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },

    resetDeepDuck: () => async (dispatch) => {
      dispatch({ type: types.RESET_DEEP_DUCK });
    }

  })
});
